var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "blocks" }, [
        _c("div", { staticClass: "row pt-3 l-m-b-20 r" }, [
          _c("div", { staticClass: "col-md-10 d-flex align-items-center" }, [
            _c("h1", { staticClass: "pr-3" }, [_vm._v("Claims")]),
            _vm._v(" "),
            _c("div", { staticClass: "input-group search" }, [
              _c(
                "button",
                {
                  staticClass: "btn input-group-btn",
                  attrs: { type: "button" },
                  on: { click: _vm.clearSearch }
                },
                [_c("i", { class: [_vm.q ? "fa fa-remove" : "fa fa-search"] })]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.q,
                    expression: "q"
                  }
                ],
                staticClass: "form-control search-input",
                attrs: { type: "text", placeholder: "Search" },
                domProps: { value: _vm.q },
                on: {
                  keydown: function($event) {
                    _vm.searchText($event)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.q = $event.target.value
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-2" },
            [
              _c("load-filter-dropdown", {
                attrs: { route: _vm.$route.name },
                on: {
                  filterSelected: _vm.loadFilters,
                  filterTemplatesInitialized: _vm.setFilterTemplatesInitialized
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row search-wrap" }, [
          _c("div", { staticClass: "col-11 filters-field pl-0" }, [
            _c("span", [_vm._v("Filters:")]),
            _vm._v(" "),
            _vm.filtersLoaded
              ? _c("span", [
                  _vm.filters.company.length && _vm.companies
                    ? _c(
                        "span",
                        _vm._l(_vm.filters.company, function(company) {
                          return _c(
                            "span",
                            {
                              key: company,
                              staticClass: "filter-item btn btn-filter"
                            },
                            [
                              _c("span", {
                                staticClass: "mod-icon-filter",
                                on: {
                                  click: function($event) {
                                    _vm.removeFilter("company", company)
                                  }
                                }
                              }),
                              _vm._v(
                                "\n              Company: " +
                                  _vm._s(
                                    _vm.companies.find(function(el) {
                                      return el.id === company
                                    }).name
                                  )
                              )
                            ]
                          )
                        })
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.carrier.length && _vm.carriers
                    ? _c(
                        "span",
                        _vm._l(_vm.filters.carrier, function(carrier) {
                          return _c(
                            "span",
                            {
                              key: carrier,
                              staticClass: "filter-item btn btn-filter"
                            },
                            [
                              _c("span", {
                                staticClass: "mod-icon-filter",
                                on: {
                                  click: function($event) {
                                    _vm.removeFilter("carrier", carrier)
                                  }
                                }
                              }),
                              _vm._v(
                                "\n              Carrier: " +
                                  _vm._s(
                                    _vm.carriers.find(function(el) {
                                      return el.id === carrier
                                    }).name
                                  )
                              )
                            ]
                          )
                        })
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.claimType.length && _vm.claimTypes
                    ? _c(
                        "span",
                        _vm._l(_vm.filters.claimType, function(claimType) {
                          return _c(
                            "span",
                            {
                              key: claimType,
                              staticClass: "filter-item btn btn-filter"
                            },
                            [
                              _c("span", {
                                staticClass: "mod-icon-filter",
                                on: {
                                  click: function($event) {
                                    _vm.removeFilter("claimType", claimType)
                                  }
                                }
                              }),
                              _vm._v(
                                "\n              Claim type: " +
                                  _vm._s(
                                    _vm.claimTypes.find(function(el) {
                                      return el.id === claimType
                                    }).name
                                  )
                              )
                            ]
                          )
                        })
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.claimCreatedDate
                    ? _c(
                        "span",
                        { staticClass: "filter-item btn btn-filter" },
                        [
                          _c("span", {
                            staticClass: "mod-icon-filter",
                            on: {
                              click: function($event) {
                                _vm.removeFilter("claimCreatedDate")
                              }
                            }
                          }),
                          _vm._v(
                            "\n            Created At: " +
                              _vm._s(_vm.filters.claimCreatedDate)
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.clusterUser.length
                    ? _c(
                        "span",
                        _vm._l(_vm.filters.clusterUser, function(clusterUser) {
                          return _c(
                            "span",
                            {
                              key: clusterUser,
                              staticClass: "filter-item btn btn-filter"
                            },
                            [
                              _c("span", {
                                staticClass: "mod-icon-filter",
                                on: {
                                  click: function($event) {
                                    _vm.removeFilter("clusterUser", clusterUser)
                                  }
                                }
                              }),
                              _vm._v(
                                "\n              Claim agent: " +
                                  _vm._s(
                                    _vm.claimsFilter.find(function(el) {
                                      return el.id === clusterUser
                                    }).full_name
                                  )
                              )
                            ]
                          )
                        })
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.claimStatusId.length
                    ? _c(
                        "span",
                        _vm._l(_vm.filters.claimStatusId, function(
                          claimStatusId
                        ) {
                          return _c(
                            "span",
                            {
                              key: claimStatusId,
                              staticClass: "filter-item btn btn-filter"
                            },
                            [
                              _c("span", {
                                staticClass: "mod-icon-filter",
                                on: {
                                  click: function($event) {
                                    _vm.removeFilter(
                                      "claimStatusId",
                                      claimStatusId
                                    )
                                  }
                                }
                              }),
                              _vm._v(
                                "\n              Status: " +
                                  _vm._s(
                                    _vm.claimStatuses.find(function(el) {
                                      return el.id === claimStatusId
                                    }).name
                                  )
                              )
                            ]
                          )
                        })
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.tags && _vm.filters.tags.length && _vm.tags
                    ? _c(
                        "span",
                        _vm._l(_vm.filters.tags, function(tag) {
                          return _c(
                            "span",
                            {
                              key: tag,
                              staticClass: "filter-item btn btn-filter"
                            },
                            [
                              _c("span", {
                                staticClass: "mod-icon-filter",
                                on: {
                                  click: function($event) {
                                    _vm.removeFilter("tags", tag)
                                  }
                                }
                              }),
                              _vm._v(
                                "\n              Tag: " +
                                  _vm._s(
                                    _vm.tags.find(function(el) {
                                      return el.id === tag
                                    }).name
                                  ) +
                                  " "
                              )
                            ]
                          )
                        })
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-secondary add-filters",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    _vm.showFilters = true
                  }
                }
              },
              [_c("i", { staticClass: "fa fa-plus filter-icon" })]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-1 d-flex justify-content-end pr-0" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary expand-all",
                attrs: { type: "button" },
                on: { click: _vm.toggleAllClaims }
              },
              [
                _c("i", {
                  class: [
                    _vm.claims && _vm.expandedAll
                      ? "fa fa-compress"
                      : "fa fa-expand"
                  ]
                })
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      !_vm.claims
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : [
            _c(
              "div",
              { staticClass: "blocks" },
              _vm._l(_vm.claims, function(claim, index) {
                return _c("ClaimBlock", {
                  key: index,
                  attrs: {
                    claim: claim,
                    expanded: _vm.expanded,
                    "claims-resolutions": _vm.claimResolutions
                  },
                  on: { expanded: _vm.toggleClaim, update: _vm.getClaims }
                })
              })
            ),
            _vm._v(" "),
            _vm.claims && !_vm.claims.length
              ? _c("div", { staticClass: "claims" }, [
                  _vm._v("\n      No claims added.\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row blocks" },
              [
                _vm.meta.total
                  ? _c("div", { staticClass: "col-md-6 mb-1 text-black-50" }, [
                      _vm._v(
                        "\n        Showing " +
                          _vm._s(_vm.meta.from) +
                          " - " +
                          _vm._s(_vm.meta.to) +
                          " of " +
                          _vm._s(_vm.meta.total) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("pagination", {
                  staticClass: "col-md-6 mb-1",
                  attrs: { "change-page": _vm.changePage, meta: _vm.meta }
                })
              ],
              1
            )
          ],
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showFilters
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showFilters = false
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "filters-side-modal flex flex-column" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "pointer",
                        on: {
                          click: function($event) {
                            _vm.showFilters = !_vm.showFilters
                          }
                        }
                      },
                      [
                        _c("h1", { staticClass: "modal-h1 l-m-b-20" }, [
                          _c("span", { staticClass: "btn btn-back" }),
                          _vm._v("Add Filter")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", [
                      _c("p", [
                        _vm._v(
                          "\n            Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.\n          "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "l-bg-white" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("div", { staticClass: "row filters" }, [
                            _vm.companies && _vm.companies.length
                              ? _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Company")]),
                                      _vm._v(" "),
                                      _c("key-multiselect", {
                                        attrs: {
                                          options: _vm.companies,
                                          multiple: true,
                                          "clear-on-select": false,
                                          "hide-selected": true,
                                          "preserve-search": false,
                                          label: "name",
                                          "track-by": "id"
                                        },
                                        on: { input: _vm.search },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "tag",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "multiselect__tag"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.option.name
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass:
                                                        "multiselect__tag-icon",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          props.remove(
                                                            props.option
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.filters.company,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "company",
                                              $$v
                                            )
                                          },
                                          expression: "filters.company"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.carriers && _vm.carriers.length
                              ? _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Carriers")]),
                                      _vm._v(" "),
                                      _c("key-multiselect", {
                                        attrs: {
                                          options: _vm.carriers,
                                          multiple: true,
                                          "clear-on-select": false,
                                          "close-on-select": false,
                                          "hide-selected": true,
                                          id: "carrier-select",
                                          placeholder: "Select Carrier",
                                          "preserve-search": false,
                                          label: "name",
                                          "track-by": "id"
                                        },
                                        on: { input: _vm.search },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "tag",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "multiselect__tag"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.option.name
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass:
                                                        "multiselect__tag-icon",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          props.remove(
                                                            props.option
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.filters.carrier,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "carrier",
                                              $$v
                                            )
                                          },
                                          expression: "filters.carrier"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.claimTypes && _vm.claimTypes.length
                              ? _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Claim types")]),
                                      _vm._v(" "),
                                      _c("key-multiselect", {
                                        attrs: {
                                          options: _vm.claimTypes,
                                          multiple: true,
                                          "clear-on-select": false,
                                          "hide-selected": true,
                                          "preserve-search": false,
                                          label: "name",
                                          "track-by": "id"
                                        },
                                        on: { input: _vm.search },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "tag",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "multiselect__tag"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.option.name
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass:
                                                        "multiselect__tag-icon",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          props.remove(
                                                            props.option
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.filters.claimType,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "claimType",
                                              $$v
                                            )
                                          },
                                          expression: "filters.claimType"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "select-wrap" },
                                [
                                  _c("label", [_vm._v("Claim created date")]),
                                  _vm._v(" "),
                                  _c("flat-pickr", {
                                    staticClass: "simple-select-input",
                                    attrs: {
                                      config: _vm.config,
                                      placeholder: "Select Created Date",
                                      name: "date"
                                    },
                                    on: { "on-close": _vm.onCreatedDateChange },
                                    model: {
                                      value: _vm.filters.claimCreatedDate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "claimCreatedDate",
                                          $$v
                                        )
                                      },
                                      expression: "filters.claimCreatedDate"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.filters.claimCreatedDate
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "position-absolute clear-date",
                                          on: {
                                            click: _vm.clearCreatedDateAndSearch
                                          }
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "mod-icon-clear"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "sr-only",
                                              attrs: { "aria-hidden": "true" }
                                            },
                                            [_vm._v("Clear")]
                                          )
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticClass:
                                            "position-absolute clear-date clear-date-transparent"
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "mod-icon-rates-dark"
                                          })
                                        ]
                                      )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _vm.claimsFilter && _vm.claimsFilter.length
                              ? _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Claim agent")]),
                                      _vm._v(" "),
                                      _c("key-multiselect", {
                                        attrs: {
                                          options: _vm.claimsFilter,
                                          multiple: true,
                                          "clear-on-select": false,
                                          "close-on-select": false,
                                          "hide-selected": true,
                                          id: "sales-claim-agent",
                                          placeholder: "Select Claim agent",
                                          "preserve-search": false,
                                          label: "full_name",
                                          "track-by": "id"
                                        },
                                        on: { input: _vm.search },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "tag",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "multiselect__tag"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.option.full_name
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass:
                                                        "multiselect__tag-icon",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          props.remove(
                                                            props.option
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.filters.clusterUser,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "clusterUser",
                                              $$v
                                            )
                                          },
                                          expression: "filters.clusterUser"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "select-wrap" },
                                [
                                  _c("label", [_vm._v("Status")]),
                                  _vm._v(" "),
                                  _c("key-multiselect", {
                                    attrs: {
                                      options: _vm.claimStatuses,
                                      multiple: true,
                                      "clear-on-select": false,
                                      "hide-selected": true,
                                      "preserve-search": false,
                                      label: "name",
                                      "track-by": "id"
                                    },
                                    on: { input: _vm.search },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "tag",
                                        fn: function(props) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "multiselect__tag"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(props.option.name)
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass:
                                                    "multiselect__tag-icon",
                                                  on: {
                                                    click: function($event) {
                                                      props.remove(props.option)
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ]),
                                    model: {
                                      value: _vm.filters.claimStatusId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "claimStatusId",
                                          $$v
                                        )
                                      },
                                      expression: "filters.claimStatusId"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _vm.$_can("tags.show")
                              ? _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Tags")]),
                                      _vm._v(" "),
                                      _c("key-multiselect", {
                                        staticClass: "w-100",
                                        attrs: {
                                          options: _vm.tags,
                                          multiple: true,
                                          "clear-on-select": false,
                                          "close-on-select": false,
                                          "track-by": "id",
                                          label: "name"
                                        },
                                        on: { input: _vm.search },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "tag",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "multiselect__tag p-0 bg-transparent"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      [
                                                        _c("tag-color", {
                                                          attrs: {
                                                            color:
                                                              props.option.color
                                                                .name,
                                                            name:
                                                              props.option.name
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          },
                                          {
                                            key: "option",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "option__desc"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex align-items-center justify-content-between"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "option__title"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                              " +
                                                                _vm._s(
                                                                  props.option
                                                                    .name
                                                                ) +
                                                                "\n                            "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.filters.tags,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filters, "tags", $$v)
                                          },
                                          expression: "filters.tags"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-auto" }, [
                      _c("div", { staticClass: "col" }, [
                        !_vm.clearFiltersButtonShouldBeDisabled
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-not-active text-dark w-100",
                                attrs: { type: "button" },
                                on: { click: _vm.clearFilters }
                              },
                              [
                                _vm._v(
                                  "\n              Clear filters\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" }, [
                        !_vm.clearFiltersButtonShouldBeDisabled
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary text-white w-100",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    _vm.saveFiltersModal = true
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              Save filters\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ])
                  ]
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.saveFiltersModal
        ? _c("SaveFiltersModal", {
            attrs: { filters: _vm.filters, route: _vm.$route.path },
            on: {
              close: function($event) {
                _vm.saveFiltersModal = false
              }
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64c395cf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64c395cf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/claims/Claims.vue
// module id = null
// module chunks = 